module.exports = __webpack_public_path__ + "media/src/images/mails/badge_grade_a-3ff829b2564c0359f9f97c0e27913068.png";